import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Header from "Components/Header";
import EditUserBox from "Components/EditUserBox/EditUserBox";
import styled from "styled-components";
import { BsPlusCircle } from "react-icons/bs";
import { Color } from "Styles/Theme";
import { fixoApi } from "Api";
import { device } from "Styles/Media";

const EditUser = () => {
  const [load, setLoad] = useState(false);
  const [boxList, setBoxList] = useState([]);
  const [editFormValue, setEditFormValue] = useState([]);
  const history = useHistory();

  useEffect(() => {
    const companyValue = sessionStorage.getItem("company");
    const jobPositionValue = sessionStorage.getItem("jobPosition");
    setEditFormValue([companyValue, jobPositionValue]);
    setLoad(true);
    addComponent();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    // eslint-disable-next-line
  }, []);

  const addComponent = () => {
    setBoxList([
      ...boxList,
      { id: boxList.length + 1, question: "", answer: "" },
    ]);
    setTimeout(() => {
      const innerHeight = window.innerHeight;
      window.scrollBy({ top: innerHeight, left: 0, behavior: "smooth" });
    }, 300);
  };

  const saveEdit = async () => {
    try {
      const res = await fixoApi.sandEditUsersList({
        company: editFormValue[0],
        job_position: editFormValue[1],
        statement: boxList,
        is_completed: 0,
      });
      if (res.status === 200) {
        window.alert("저장되었습니다.");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const submitEdit = async () => {
    try {
      await fixoApi.sandEditUsersList({
        company: editFormValue[0],
        job_position: editFormValue[1],
        statement: boxList,
        is_completed: 1,
      });
      history.push("/editlist");
      sessionStorage.removeItem("company");
      sessionStorage.removeItem("jobPosition");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Container>
      <Header />
      <EditUserBoxWrap fadeDown={load}>
        {boxList.map((data) => (
          <EditUserBox
            key={data.id}
            boxList={boxList}
            setBoxList={setBoxList}
            id={data.id}
            question={data.question}
            answer={data.answer}
          />
        ))}
      </EditUserBoxWrap>
      <BsPlusCircle className="addContentBox" onClick={addComponent} />
      <ButtonWrap>
        <div>
          <Button onClick={saveEdit}>저장하기</Button>
          <Button onClick={submitEdit}>제출하기</Button>
        </div>
      </ButtonWrap>
    </Container>
  );
};

export default EditUser;

const Container = styled.section`
  position: relative;
  padding-bottom: 150px;
  min-height: 100vh;
  .addContentBox {
    font-size: 28px;
    display: block;
    margin: 0 auto;
    color: ${Color.purple};
    cursor: pointer;
  }
`;
const EditUserBoxWrap = styled.div`
  animation: ${(props) => (props.fadeDown ? "fadeUp" : "")};
  animation-duration: 0.8s;
  animation-iteration-count: 1;
  animation-fill-mode: both;
  @keyframes fadeUp {
    0% {
      opacity: 0;
      margin-top: -200px;
    }
    40% {
      opacity: 0;
    }
    100% {
      margin-top: 50px;
      opacity: 1;
    }
  }
`;
const ButtonWrap = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  padding: 30px 0;
  border-top: 1px solid #ddd;
  div {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    @media ${device.mobile} {
      justify-content: center;
    }
  }
`;
const Button = styled.button`
  width: 160px;
  height: 50px;
  margin-left: 20px;
  font-size: 14px;
  border: 0;
  border-radius: 10px;
  background-color: ${Color.purple};
  color: #fff;
  cursor: pointer;
  outline: 0;
  &:hover {
    opacity: 0.9;
  }
  @media ${device.mobile} {
    margin: 0 5px;
  }
`;
